/**
 * `TutorialScenarioSource` 어댑터 — generated/tutorialScenarios.json을 로드해 scenarioId별 스텝을 제공.
 *
 * 파싱/검증은 `tutorialRowParser`(순수)가 담당. 이 클래스는 JSON import + 캐시만.
 * `moduleDefinitions.ts`가 generated/modules.json을 import하는 패턴과 동일.
 */
import tutorialJson from "../data/generated/tutorialScenarios.json";
import type { TutorialScenario, TutorialScenarioSource } from "@yjsgames/phaser-tutorial";
import { parseTutorialRows, type RawTutorialRow } from "./tutorialRowParser.js";

export class JsonTutorialScenarioSource implements TutorialScenarioSource {
  private readonly byScenario = parseTutorialRows(tutorialJson as RawTutorialRow[]);

  getScenario(scenarioId: string): TutorialScenario {
    return this.byScenario.get(scenarioId) ?? [];
  }

  /** generated json에 정의된 모든 scenarioId(파싱·정렬 그룹의 키, json 행 등장 순서). 치트 시나리오 선택 드롭다운용. */
  getScenarioIds(): string[] {
    return [...this.byScenario.keys()];
  }
}
